module.exports = require("./ms-MY.js");